import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';

export class MissingActionFilter extends BaseActionFilter {
    getMissingOpenModalSuccess = () => {
        const getMissingOpenModalSuccess = {
            page: {
                pageInfo: {
                    name: 'missing reward points success - modal',
                },
            },
        };
        return getMissingOpenModalSuccess;
    };

    getMissingOpenModalError = (data) => {
        const getMissingPointModalError = {
            error: [{ errorDescription: data }],
        };
        return getMissingPointModalError;
    };
}

export default MissingActionFilter;
